import type { GeodataDataType } from '@visualizer/types';

export interface IApiRoutes {
    gridDownload(gridId: string): string;
    geodataDownload(geodataId: string, dataType: GeodataDataType): string;
    raysDownload(simulationSetId: string, subSimulationId: number, raysAssetKind: string): string;
    resultDownload(simulationSetId: string, subSimulationId: number, resultId: number): string;
    resultsList(simulationSetId: string, subSimulationId: number): string;
    canUseApi(): boolean;
}

let activeRoutes: IApiRoutes | null = null;

export const setApiRoutes = (routes: IApiRoutes) => {
    activeRoutes = routes;
};

export const ApiRoutes: IApiRoutes = {
    gridDownload(gridId) {
        return activeRoutes!.gridDownload(gridId);
    },
    geodataDownload(geodataId, dataType) {
        return activeRoutes!.geodataDownload(geodataId, dataType);
    },
    raysDownload(simulationSetId, subSimulationId, raysAssetKind) {
        return activeRoutes!.raysDownload(simulationSetId, subSimulationId, raysAssetKind);
    },
    resultDownload(simulationSetId, subSimulationId, resultId) {
        return activeRoutes!.resultDownload(simulationSetId, subSimulationId, resultId);
    },
    resultsList(simulationSetId, subSimulationId) {
        return activeRoutes!.resultsList(simulationSetId, subSimulationId);
    },
    canUseApi() {
        return activeRoutes!.canUseApi();
    },
};
